import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { convertArrayFromDropdownProperties } from '../../../shared/helpers';

import { TeamOptionsActionType, TeamOptionsStore } from './TeamOptionsReducer.types';

// @ts-ignore
export const initialState: TeamOptionsStore = Immutable.fromJS({
  countryOptions: null,
  universityOptions: null,
  countryOptionsList: null,
  universityOptionsList: null,
  countryRequired: null,
  universityRequired: null,
  minRequiredMembers: null,
  maxRequiredMembers: null,
  isFetching: false,
  maxNameLength: null,
  isUniversityReadOnly: false,
  isCountryReadOnly: false,
  isMembersReadOnly: false,
});

const orderMetadataDropdown = (metadata: any, key: string = 'label') =>
  metadata.sort((x: any, y: any) => (x && y && x.value === x[key] ? -1 : x[key].localeCompare(y[key])));

const TeamOptionsReducer = handleActions<any>(
  {
    TEAM_OPTIONS_REQUEST: (state: TeamOptionsStore) => state.set('isFetching', true),
    TEAM_OPTIONS_RESPONSE_FAILURE: (state: TeamOptionsStore) => state.set('isFetching', false),
    ADD_UNIVERSITY_TO_TEAMS: (state: TeamOptionsStore, action: TeamOptionsActionType) => {
      const universityData = state.get('universityOptionsList').toJS();

      return state.set('universityOptionsList', Immutable.fromJS(orderMetadataDropdown(universityData.concat([action.payload]), 'text')));
    },
    TEAM_OPTIONS_RESPONSE_SUCCESS: (state: TeamOptionsStore, action: TeamOptionsActionType) => {
      const countryOptions: any = {};
      if (action.payload.country && action.payload.country.choices) {
        action.payload.country.choices.forEach((country: any) => {
          countryOptions[country.value] = country.label; //todo: fix it on back end
        });
      }
      const universityOptions: any = {};
      if (action.payload.university && action.payload.university.choices) {
        action.payload.university.choices.map((university: any) => {
          universityOptions[university.value] = university.label;
        });
      }

      return state
        .set('isFetching', false)
        .set('countryOptions', Immutable.fromJS(countryOptions))
        .set('universityOptions', Immutable.fromJS(universityOptions))
        .set(
          'countryOptionsList',
          action.payload.country &&
            Immutable.fromJS(convertArrayFromDropdownProperties(orderMetadataDropdown(action.payload.country.choices)))
        )
        .set(
          'universityOptionsList',
          action.payload.university &&
            Immutable.fromJS(convertArrayFromDropdownProperties(orderMetadataDropdown(action.payload.university.choices)))
        )
        .set('countryRequired', action.payload.country?.required)
        .set('universityRequired', action.payload.university?.required)
        .set('maxNameLength', action.payload.name?.maxLength)
        .set('minRequiredMembers', action.payload.members?.minLength)
        .set('maxRequiredMembers', action.payload.members?.maxLength)
        .set('isMembersReadOnly', action.payload.members?.readOnly)
        .set('isUniversityReadOnly', action.payload.university?.readOnly)
        .set('isCountryReadOnly', action.payload.country?.readOnly);
    },
    USER_TEAMS_RESPONSE: (state: TeamOptionsStore, action: TeamOptionsActionType) => {
      const universityOptionsList = state.get('universityOptionsList');
      if (
        universityOptionsList &&
        action.payload.data.results &&
        action.payload.data.results.length > 0 &&
        action.payload.data.results[0].status === 'ACTIVE'
      ) {
        const universityName = action.payload.data.results[0].university;
        const universityExists = universityOptionsList.find((element: any) => element.get('value') === universityName);
        if (!universityExists) {
          const universityData = universityOptionsList.toJS();
          const university = { key: universityName, value: universityName, text: universityName };

          return state.set('universityOptionsList', Immutable.fromJS(orderMetadataDropdown(universityData.concat([university]), 'text')));
        }
      }

      return state;
    },
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default TeamOptionsReducer;
